module.exports = "/_next/static/images/SantaClaraLogo-d43ae13300be458875994dc2765b80d9.png";